<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout column>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="search"
            solo
            append-icon="search"
            label="Search ...">
          </v-text-field>
        </v-flex>
        <v-flex v-if="tools.length === 0" xs6>
          <SharedContentLoader v-for="i in 5" :key="i"></SharedContentLoader>
        </v-flex>
        <v-flex v-else xs6 class="mt-2">
          <v-list two-line>
            <template v-for="(tool, index) in filteredTools">
              <v-list-tile avatar :href="tool.url" target="_blank">
                <v-list-tile-content>
                  <v-list-tile-title>{{ tool.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ tool.description }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-chip :style="{ 'background-color': color(tool.type)}" label>{{ tool.type.toUpperCase() }}</v-chip>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  import crypto from 'crypto';
  import SharedContentLoader from './Shared/SharedContentLoader';

  export default {
    name: 'tools',
    components: {
      SharedContentLoader,
    },
    data() {
      return {
        tools: [],
        search: '',
      };
    },
    computed: {
      filteredTools() {
        if (this.search === '') {
          return this.tools;
        }

        const arr = Object.keys(this.tools).map(k => this.tools[k]);

        return arr.filter(tool =>
          tool.name.toLowerCase().includes(this.search.toLowerCase()) ||
          tool.description.toLowerCase().includes(this.search.toLowerCase()),
        );
      },
    },
    methods: {
      md5(string) {
        return crypto.createHash('md5').update(string).digest('hex');
      },
      color(string) {
        return `#${this.md5(string).slice(0, 6)}`;
      },
      async fetchTools() {
        const tools = await this.$database().ref('tools').once('value');
        this.tools = tools.val();
      },
    },
    mounted() {
      this.fetchTools();
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Shared.vue